module.exports = __webpack_public_path__ + "static/media/facebook_icon.c610ef88.svg";